/**
 * The class representing the {@link Ball}
 */
var Field = /** @class */ (function () {
    /**
     * Field position
     * @param x X position
     * @param y Y position
     */
    function Field(x, y) {
        this.x = x;
        this.y = y;
        this.costs = { roadCost: 0, distanceCost: 0 };
        this.cost = 0;
        this.free = true;
        this.div = document.createElement("div");
        this.div.classList.add("field");
    }
    /** @inheritdoc */
    Field.prototype.restartField = function () {
        this.costs = { roadCost: 0, distanceCost: 0 };
        this.cost = 0;
        this.parent = undefined;
    };
    /** @inheritdoc */
    Field.prototype.calculateCost = function (target, parent) {
        var distanceToStart;
        if (parent) {
            distanceToStart = parent.costs.roadCost + 1;
        }
        else {
            distanceToStart = 1;
        }
        var distanceToTarget = this.calculateDistance(target);
        return { roadCost: distanceToStart, distanceCost: distanceToTarget };
    };
    /** @inheritdoc */
    Field.prototype.setCost = function (costs) {
        this.cost = costs.roadCost + costs.distanceCost;
        this.costs = costs;
    };
    /** @inheritdoc */
    Field.prototype.addBall = function (ball) {
        this.child = ball;
        ball.parent = this;
        this.free = false;
        this.div.appendChild(ball.div);
    };
    /** @inheritdoc */
    Field.prototype.removeBall = function () {
        if (this.child) {
            this.div.removeChild(this.child.div);
            this.free = true;
            return this.child;
        }
        else {
            return null;
        }
    };
    /** @inheritdoc */
    Field.prototype.addClass = function (className) {
        this.div.classList.add(className);
    };
    /** @inheritdoc */
    Field.prototype.removeClass = function (className) {
        this.div.classList.remove(className);
    };
    /**
     * Method to calculate the distance between the current {@link Field} and the target {@link Field}
     * @param target Target {@link Field}
     * @returns Distance between {@link Field | Fields}
     */
    Field.prototype.calculateDistance = function (target) {
        return Math.abs(target.x - this.x) + Math.abs(target.y - this.y);
    };
    return Field;
}());
export { Field };
